import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import JiuJitsuPage from "./pages/JiuJitsuPage";
import KidsJiuJitsuPage from "./pages/KidsJiuJitsuPage";
import MmaPage from "./pages/MmaPage";
import MuayThaiPage from "./pages/MuayThaiPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProgramsPage from "./pages/ProgramsPage";
import ReviewsPage from "./pages/ReviewsPage";
import SchedulePage from "./pages/SchedulePage";
import TeensJiuJitsuPage from "./pages/TeensJiuJitsuPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import WrestlingPage from "./pages/WrestlingPage";
import {
  RouterProvider,
  createRootRoute,
  createRoute,
  createRouter,
} from "@tanstack/react-router";

const rootRoute = createRootRoute();

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contact-us",
  component: ContactPage,
});

const scheduleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/schedule",
  component: SchedulePage,
});

const aboutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/about-us",
  component: AboutPage,
});

const jiuJitsuRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs/jiu-jitsu",
  component: JiuJitsuPage,
});

const kidsJiuJitsuRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs/kids-jiu-jitsu",
  component: KidsJiuJitsuPage,
});

const teensJiuJitsuRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs/teens-jiu-jitsu",
  component: TeensJiuJitsuPage,
});

const mmaRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs/mma",
  component: MmaPage,
});

const muayThaiRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs/muay-thai",
  component: MuayThaiPage,
});

const wrestlingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs/wrestling",
  component: WrestlingPage,
});

const programsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs",
  component: ProgramsPage,
});

const privacyPolicyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/privacy-policy",
  component: PrivacyPolicyPage,
});

const termsAndConditionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/terms-and-conditions",
  component: TermsAndConditionsPage,
});

const reviewsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reviews",
  component: ReviewsPage,
});

const routeTree = rootRoute.addChildren([
  homeRoute,
  contactRoute,
  scheduleRoute,
  aboutRoute,
  jiuJitsuRoute,
  kidsJiuJitsuRoute,
  teensJiuJitsuRoute,
  mmaRoute,
  muayThaiRoute,
  wrestlingRoute,
  programsRoute,
  privacyPolicyRoute,
  termsAndConditionsRoute,
  reviewsRoute,
]);

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  return <RouterProvider router={router} />;
}
